import { Minus, Plus } from 'lucide-react';
import { useState } from 'react';

const TABLE_ZOOM_MIN = 10;
const TABLE_ZOOM_MAX = 100;
const TABLE_ZOOM_STEP = 10;
const TABLE_ZOOM_DEFAULT = 60;

export function useTableZoom() {
  const [zoom, setZoom] = useState(TABLE_ZOOM_DEFAULT);

  const changeZoom = (direction) => {
    setZoom((current) => Math.max(
      TABLE_ZOOM_MIN,
      Math.min(TABLE_ZOOM_MAX, current + (direction * TABLE_ZOOM_STEP))
    ));
  };

  return {
    zoom,
    zoomOut: () => changeZoom(-1),
    zoomIn: () => changeZoom(1),
    canZoomOut: zoom > TABLE_ZOOM_MIN,
    canZoomIn: zoom < TABLE_ZOOM_MAX,
  };
}

export default function TableZoomControls({ zoom, zoomOut, zoomIn, canZoomOut, canZoomIn }) {
  return (
    <div className="mobile-table-zoom-controls" aria-label="Zoom tabella">
      <span>Zoom tabella</span>
      <button
        type="button"
        onClick={zoomOut}
        disabled={!canZoomOut}
        aria-label="Riduci zoom tabella"
      >
        <Minus size={16} aria-hidden="true" />
      </button>
      <strong aria-live="polite">{zoom}%</strong>
      <button
        type="button"
        onClick={zoomIn}
        disabled={!canZoomIn}
        aria-label="Aumenta zoom tabella"
      >
        <Plus size={16} aria-hidden="true" />
      </button>
    </div>
  );
}
